import { Col, Row, Table } from "antd";
import { useEffect, useState } from "react";

import { CircleButton } from "./Buttons";
import SectionLabel from "./SectionLabel";
import useCollectors from "../hooks/useCollectors";

//leaderboard
const Ranking = () => {
  const [dataSource, setDataSource] = useState();
  const { getLeaderBoard } = useCollectors();

  useEffect(() => {
    async function fetchData() {
      const dataLeader = await getLeaderBoard();
      setDataSource(dataLeader);
    }

    fetchData();

    const interval = setInterval(() => {
      fetchData();
    }, 5000);
    console.log(dataSource);
    return () => clearInterval(interval);
  }, []);

  if (!dataSource)
    <div>
      <p>loading...</p>
    </div>;

  const columns = [
    { title: "#", dataIndex: "rank" },
    { title: "", dataIndex: "", render: () => <CircleButton size={25} /> },
    {
      title: "Nombre",
      dataIndex: "ethAddress",
      render: (a) => a.slice(0, 4) + "..." + a.slice(a.length - 4, a.length),
    },
    { title: "OPIS", dataIndex: "runes" },
  ];

  const buttonsData = [{ text: "Todos" }, { text: "Comunidades" }, { text: "Usuarios" }];

  return (
    <Row>
      <Col style={styles.title}>
        <h1 style={{ color: "white", fontWeight: "700", margin: 0 }}>Posiciones</h1>
        <div style={styles.title.btns}>
          <SectionLabel data={buttonsData} style={styles.title.btns.btn} invertColor={true} />
        </div>
      </Col>

      <Col span={24}>
        {dataSource && (
          <Table
            columns={columns}
            dataSource={dataSource.slice(0, 10)}
            style={styles.rankingTable}
            pagination={false}
          />
        )}
      </Col>
    </Row>
  );
};

export default Ranking;

const styles = {
  title: {
    marginTop: "24px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    width: "100%",
    btns: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "8px",
      btn: { width: "fit-content", height: "fit-content", fontWeight: "500" },
    },
  },
  rankingTable: {
    borderRadius: "20px ",
    height: window.innerHeight - 450,
    overflowY: "overlay",
    overflowX: "hidden",
  },
};
